import './toolBarPanel.scss';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { useMessagesStore } from '@/stores/messages';
import { useMeetingStore } from '@/stores/meeting';
import { useUserStore } from '@/stores/user';
import { ParticipantRole } from '@/consts/meeting';
import { useWindowWidth } from '@/hooks/useWindowWidth';
import clsx from 'clsx';

function SwitcherFileToBoard() {
  const { participantActiveCanvas, setParticipantActiveCanvas } = useUserStore();
  return (
    <Button
      icon={clsx(
        'pi',
        participantActiveCanvas === 'canvasFile' ? 'pi-file-pdf' : 'pi-pen-to-square'
      )}
      className="switcher-file-to-board"
      onClick={() => {
        if (participantActiveCanvas === 'canvasBoard') {
          setParticipantActiveCanvas('canvasFile');
        } else {
          setParticipantActiveCanvas('canvasBoard');
        }
      }}
    />
  );
}

export default function StudentsChatsLayout() {
  const { unreadCount } = useMessagesStore();
  const { studentNotifications, resetStudentNotifications } = useMeetingStore();
  const { activeToolPanel, setActiveToolPanel } = useMeetingStore();
  const { role } = useUserStore();
  const windowWidth = useWindowWidth();

  return (
    <div className="sidebar">
      <div className="sidebar__toolbar-buttons">
        <Button
          style={{ fontSize: '1rem' }}
          className={activeToolPanel === 'participants' ? 'active' : ''}
          onClick={() => {
            if (activeToolPanel === 'participants') {
              setActiveToolPanel('');
            } else {
              setActiveToolPanel('participants');
            }
            resetStudentNotifications();
          }}
        >
          <span className="icon-inner pi pi-users">
            {studentNotifications > 0 && role !== ParticipantRole.STUDENT && (
              <Badge value={studentNotifications} className="icon-badge" />
            )}
          </span>
        </Button>
        <Button
          className={activeToolPanel === 'chat' ? 'active' : ''}
          onClick={() => {
            if (activeToolPanel === 'chat') {
              setActiveToolPanel('');
            } else {
              setActiveToolPanel('chat');
            }
          }}
        >
          <span className="icon-inner pi pi-comments">
            {unreadCount > 0 && <Badge value={unreadCount} className="icon-badge" />}
          </span>
        </Button>
        <Button
          icon="pi pi-file"
          className={activeToolPanel === 'docs' ? 'active' : ''}
          onClick={() => {
            if (activeToolPanel === 'docs') {
              setActiveToolPanel('');
            } else {
              setActiveToolPanel('docs');
            }
          }}
        />
        {/* <Button
        icon="pi pi-clock"
        className={activeTab === 3 ? "active" : ""}
        onClick={() => setActiveTab(3)}
      /> */}
        {windowWidth <= 1440 && windowWidth > 768 && <SwitcherFileToBoard />}
      </div>
      {windowWidth <= 768 && <SwitcherFileToBoard />}
    </div>
  );
}
